import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, Validators, UntypedFormGroup } from '@angular/forms';
import { UtilsService } from '../../services/utils.service';
import { CaptchaComponent } from '../captcha/captcha.component';
import { CaptchaVerificationDto } from '@shared/dtos/captcha-verification.dto';
import { EmailVerificationComponent } from '../email-verification/email-verification.component';
import { EmailVerificationDto } from '@shared/dtos/email-verification.dto';

@Component({
  selector: 'form-eid-form-send',
  templateUrl: './eid-form-send.component.html',
  styleUrls: ['./eid-form-send.component.scss']
})
export class EidFormSendComponent  implements OnInit {
  @Output() sendForm: EventEmitter<{ captcha: CaptchaVerificationDto, emailVerification: EmailVerificationDto, isEid: boolean }> = new EventEmitter<{ captcha: CaptchaVerificationDto, emailVerification: EmailVerificationDto, isEid: boolean }>();
  @Output() cancel: EventEmitter<void> = new EventEmitter<void>();
  @ViewChild(CaptchaComponent) captchaComponent: CaptchaComponent;
  @ViewChild(EmailVerificationComponent) emailVerificationComponent: EmailVerificationComponent;
  formGroup: UntypedFormGroup;

  @Input() captcha: boolean = true;
  @Input() emailVerification: boolean = true;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private utilsService: UtilsService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    const group: any = {};
    if(this.captcha) {
      group.captchaVerification = [null, [Validators.required]];
    }
    if(this.emailVerification) {
      group.emailVerification = [null, [Validators.required]];
    }

    this.formGroup = this.formBuilder.group(group);
  }

  async onFormSend(): Promise<void> {
    if (this.formGroup.valid) {
      const result: any = { isEid: true };

      if(this.captcha) {
        const captchaVerification: CaptchaVerificationDto =
          this.formGroup.value.captchaVerification;
      
        result.captcha = captchaVerification;
      }
      if (this.emailVerification) {
        result.emailVerification = this.formGroup.value.emailVerification;
      }
      this.sendForm.next(result);
    } else {
      this.utilsService.markFormGroupTouched(this.formGroup);
    }
  }

  onCancel(): void {
    this.cancel.next();
  }
}
